import { LoginFrom } from '@/types/views/login'
import { oauthToken, getUserInfo, loginByTokenId, logout } from '@/api/login'
import { defineStore } from 'pinia'

// 处理用户登录、登出、个人信息、权限路由
export type UserState = {
  employee: any,
  employeeId: string,
  userId: string,
  requestStatus: string,
}
let account: any = localStorage.getItem('PAI-account');
let _employee: any = null;
let _employeeId = '';
let _userId = '';

if(account){
  account = JSON.parse(account);
  _employee = account.employee;
  _employeeId = account.employee.id;
  _userId = account.userId;
}
export const userStore = defineStore({
  id: 'user-store',
  state: () => ({
    // 登录人
    'employee': _employee,
    // 人员ID
    'employeeId': _employeeId,
    // 用户ID
    'userId': _userId,
    // 登录状态
    requestStatus: '',
  }),
  getters: {
    getEmployee:(state)=> {
      return state.employee;
    },
    getEmployeeId:(state)=> {
      return state.employeeId;
    },
    getUserId:(state)=> {
      return state.userId;
    },
    getRequestStatus:(state)=> {
      return state.requestStatus;
    }
  },
  actions: {
    setEmployee(emp: any) {
      this.employee = emp.employee;
      this.employeeId = emp.employee.id;
      this.userId = emp.userId;
    },
    /**
     * @FunctionName: 登录 获取token
     * @param {ActionContext} context
     * @param {*} AllState
     * @param {LoginFrom} params
     * @return {*}
     * @Author: zhuzhaoyang
     * @Date: 2023-06-07 10:46:48
     * @Description: 
     */
    oauthToken(params: LoginFrom) {
      this.requestStatus = 'requestToken';
      return new Promise((resolve, reject) => {
        oauthToken(params).then((res: any) => {
          if (res) {
            this.requestStatus = '';
            localStorage.setItem('PAI-token', JSON.stringify(res));
            localStorage.setItem('Login-time', new Date().getTime().toString());
            getUserInfo(params).then((res: any) => {
              this.employee = res.employee;
              this.employeeId = res.employee.id;
              this.userId = res.userId;
              localStorage.setItem('PAI-account', JSON.stringify(res));
              resolve(res)
            }).catch(err => {
              reject(err)
            })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * @FunctionName: 登录 获取用户信息
     * @param {ActionContext} context
     * @param {*} AllState
     * @param {LoginFrom} params
     * @return {*}
     * @Author: zhuzhaoyang
     * @Date: 2023-06-07 10:47:06
     * @Description: 
     */
    getUserInfo(params: LoginFrom) {
      return new Promise((resolve, reject) => {
        getUserInfo(params).then((res: any) => {
          localStorage.setItem('PAI-account', JSON.stringify(res));
          resolve(res)
        }).catch((err: any) => {
          reject(err)
        })
      })
    },
    /**
     * @FunctionName: 更根据 tokenId 自动登录
     * @param {any} headers
     * @param {any} params
     * @return {*}
     * @Author: zhuzhaoyang
     * @Date: 2024-07-02 15:38:20
     * @Description: 
     */    
    loginByTokenId(headers: any, params: any) {
      return new Promise((resolve, reject) => {
        loginByTokenId(headers, params).then((res: any) => { 
          // 保存token
          localStorage.setItem('PAI-token', JSON.stringify(res.token));
          localStorage.setItem('Login-time', new Date().getTime().toString());
          localStorage.setItem('PAI-account', JSON.stringify(res.userInfo));
          this.setEmployee(res.userInfo); 
          resolve(res)
        }).catch((err: any) => {
          reject(err)
        })
      })
    },
    /**
     * @FunctionName: 退出登录
     * @param {ActionContext} context
     * @param {*} AllState
     * @return {*}
     * @Author: zhuzhaoyang
     * @Date: 2023-06-07 10:52:36
     * @Description: 
     */
    logout() {
      return new Promise((resolve, reject) => {
        logout().then(e => {
          this.employee = null;
          this.employeeId = '';
          this.userId = '';
          this.requestStatus = '';
          resolve(e)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
})